import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import ScrollTop from 'src/hooks/useScrollTop';

import 'nprogress/nprogress.css';
import { Provider } from 'react-redux';
import store from 'src/store';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { AuthProvider } from 'src/contexts/FirebaseAuthContext';

ReactDOM.render(
  <HelmetProvider>
    <Provider store={store}> 
      <AuthProvider>
        <SidebarProvider>
          <BrowserRouter>
            <ScrollTop />
            <App />
          </BrowserRouter>
        </SidebarProvider>
      </AuthProvider>
    </Provider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
